<template>
  <Layout>
    <Title
      icon="account"
      heading="Your Account"
      sub-heading="Manage your account settings and more."
    />
    <div class="container my-4">
      <form class="pb-4">
        <Input
          model="user"
          :id="user.id"
          placeholder="Your first name"
          type="text"
          field="first_name"
          label="First Name"
          :initial-value="user.first_name"
        />
        <Input
          model="user"
          :id="user.id"
          placeholder="Your last name"
          type="text"
          field="last_name"
          label="Last Name"
          :initial-value="user.last_name"
        />
        <Input
          model="user"
          locked
          :id="user.id"
          placeholder="jane.doe@example.com"
          type="email"
          field="email"
          label="Email Address"
          :initial-value="user.email"
        />
        <Input
          model="profile"
          :id="user.profile.id"
          placeholder="+44 7709 123 456"
          type="phone"
          field="phone"
          label="Phone Number"
          :initial-value="user.profile.phone"
        />
      </form>
    </div>

    <div class="container pt-4">
      <div class="row">
        <div class="col">
          <h2>Security settings</h2>
        </div>
      </div>

      <form class="py-4">
        <Password :id="user.id" />
      </form>
    </div>

    <div class="container pt-4">
      <div class="row">
        <div class="col">
          <h2>E-mail Notifications</h2>
        </div>
      </div>

      <form class="py-4">
        <div class="row">
          <div class="col-sm-6">
            <Checkbox
              :id="user.profile.id"
              field="email_notifications"
              name="updates"
              label="Updates to Clausify"
              :initial-checked="
                user.profile.email_notifications['updates'] ? true : false
              "
              :disabled="true"
            />
            <Checkbox
              :id="user.profile.id"
              field="email_notifications"
              name="laws"
              label="Updates to Laws and Regulations"
              :initial-checked="
                user.profile.email_notifications['laws'] ? true : false
              "
              :disabled="true"
            />
            <Checkbox
              :id="user.profile.id"
              field="email_notifications"
              name="action"
              label="An action is required of me"
              :initial-checked="
                user.profile.email_notifications['action'] ? true : false
              "
            />
          </div>
          <div class="col-sm-6">
            <Checkbox
              :id="user.profile.id"
              field="email_notifications"
              name="created"
              label="A document is created"
              :initial-checked="
                user.profile.email_notifications['created'] ? true : false
              "
            />
            <Checkbox
              :id="user.profile.id"
              field="email_notifications"
              name="new"
              label="A new Client or Master Services Agreement is created"
              :initial-checked="
                user.profile.email_notifications['new'] ? true : false
              "
            />
            <Checkbox
              :id="user.profile.id"
              field="email_notifications"
              name="expire"
              label="A document is due to expire in 60 days"
              :initial-checked="
                user.profile.email_notifications['expire'] ? true : false
              "
            />
          </div>
        </div>
      </form>
    </div>
  </Layout>
</template>

<script>
import Layout from '@/Shared/Layout';
import Title from '@/Shared/Title';
import Checkbox from '@/Pages/Account/Profile/Checkbox';
import Password from '@/Pages/Account/Profile/Password';
import Input from '@/Pages/Account/Profile/Input';

export default {
  components: {
    Layout,
    Title,
    Checkbox,
    Password,
    Input,
  },

  props: {
    user: {
      type: Object,
      required: true,
    },
  },
};
</script>
